import React, { useState, ChangeEvent, useEffect } from "react";

import { getAccountSubdomain } from "../../api/accounts";
import { ExclamationIcon } from "@heroicons/react/outline";
import Button from "../../components/UI/Button";

function AccountGo() {
  const [subdomain, setSubdomain] = useState("");
  const [error, setError] = useState("");
  const [invalidDomain, setInvalidDomain] = useState(false);

  useEffect(() => {
    const currentHost = window.location.host.split(".");
    if (
      currentHost[0] == "dev" ||
      currentHost[0] == "staging" ||
      currentHost.length < 3
    ) {
      setInvalidDomain(false);
    } else {
      setInvalidDomain(true);
    }
  }, []);

  const submitHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    const s = subdomain.trim();
    if (s.length < 1) {
      setError("Subdomain is required!");
      return;
    }
    try {
      const { data } = await getAccountSubdomain(s);
      if (!data.available) {
        window.location.href = `${window.location.protocol}//${s}.${window.location.host}/auth/sign_in`;
      } else {
        throw new Error();
      }
    } catch (err: any) {
      setError("We cannot find this account subdomain");
    }
  };

  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setError("");
    setSubdomain(e.target.value);
  };

  const backToRootHandler = () => {
    const hostname = window.location.host.split(".");
    const lastItem = hostname[hostname.length - 1];
    const secondLastItem = hostname[hostname.length - 2];
    const rootDomain = secondLastItem + "." + lastItem;
    window.location.href = `${window.location.protocol}//${rootDomain}`;
  };

  const renderError = () => {
    return (
      <section className="flex-grow flex justify-center items-center text-neutralColor-normal">
        <div className="flex flex-row items-start gap-4 justify-center mx-auto bg-white w-11/12 md:w-2/3 lg:w-3/5 max-w-lg shadow-2xl rounded-lg px-4 pt-6 pb-8 border-t-2 ">
          <span className="bg-red-100 rounded-full p-2">
            <ExclamationIcon className="h-6 w-6 text-tertiaryColor-normal" />
          </span>

          <div className="flex flex-col justify-cent">
            <h2 className="m-0 font-bold">Account Subdomain Error</h2>
            <p className="my-5">
              Subdomain is not allowed in this page. Please use account
              navigator to go to your account.
            </p>
            <div>
              <Button
                label="Go back to home"
                btnStyle="btn-primary"
                type="button"
                onClick={backToRootHandler}
              />
            </div>
          </div>
        </div>
      </section>
    );
  };

  const renderContent = () => {
    return (
      <div className="container mx-auto w-full flex flex-col justify-center items-center p-5 ">
        <p className="font-bold my-8 break-words text-center text-sm md:text-lg">
          https://{subdomain}.seinterminal.com
        </p>

        {!invalidDomain && (
          <form
            onSubmit={submitHandler}
            className="flex flex-col h-full gap-4 lg:gap-2 md:flex-row justify-between items-center w-full max-w-screen-sm"
          >
            <div className="w-full h-full">
              <input
                type="text"
                name="companyDomain"
                className={`py-5 w-full rounded-lg px-4 text-gray-700 leading-tight input focus:outline-none`}
                placeholder="Enter your account subdomain"
                onChange={changeHandler}
                value={subdomain}
              />
              {error.length > 0 && (
                <p className="md:absolute mt-2 text-tertiaryColor-normal text-left">
                  {error}
                </p>
              )}
            </div>
            <button
              className="bg-primaryColor-normal hover:bg-primaryColor-dark text-white rounded-md w-full py-2 md:py-4 md:w-1/4 items-center font-bold text-xl"
              type="submit"
            >
              Go
            </button>
          </form>
        )}
      </div>
    );
  };

  return (
    <>
      {!invalidDomain && renderContent()}
      {invalidDomain && renderError()}
    </>
  );
}

export default AccountGo;
